






































import { Component, Prop, Vue } from "vue-property-decorator";

import Close from "../resources/close.vue";
import { CookieHelper } from "@/helper/cookieHelper";
import { ResourceHelper } from "@/helper/resourceHelper";
import platform from '@/helper/platform';

@Component({
  components: {
      Close
  }
})

export default class onetimePass extends Vue {
    @Prop() private device! : string;
    @Prop() private isError! : boolean;
    @Prop() private errorMessages! : Array<{index : number, message: string}>;

    onetimePass = "";
    isCanSubmit = false;

    private mounted(){
        (this.$refs.onetimePass as HTMLElement).focus();
    }

    private onDoCommand(command : string, param : any){
        this.$emit("doCommand", command, param);
    }

    private setCanSubmit(){
        this.isCanSubmit = true;
    }

    private keyupEnter(element){
        if(!this.isCanSubmit){ return; }
        this.isCanSubmit = false;
        (this.$refs[element] as HTMLElement).blur();
        if(this.onetimePass == ""){ return; }
        this.inputOnetimePass();
    }

    private returnPage(){
        this.onDoCommand("returnPage", null);
    }

    private inputOnetimePass(){
        var param = {
            platformId : String(platform.id),
            onetimePass : this.onetimePass,
            installId : CookieHelper.getItem("installId"),
            certificationToken : CookieHelper.getItem("certificationToken")
        };
        this.onDoCommand("onetimePass", param);
    }

    private get getStyle(){
        var style = {};
        if(this.device == "sp"){
            style = {
                position : "fiexd",
                width: window.innerWidth + "px",
                height: window.innerHeight + "px",
                backgroundColor: this.$store.getters.userConfigColors.backgroundColor
            }
        }
        return style;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBorderColor(){
        var style = {
            border : "solid 1px " + this.userConfigColor
        };
        return style;
    }
    private get userConfigBorderBottomColor(){
        var style = {
            borderBottom : "solid 1px " + this.userConfigColor
        };
        return style;
    }
    private get userConfigButtonColor(){
        var style = {
            background : this.userConfigColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
